/**
 * Deals Serializers
 * Transform API data to match component expectations
 */

/**
 * Transform a single deal object from API format to component format
 * @param {Object} apiDeal - Deal object from API
 * @returns {Object} - Transformed deal object
 */
export function transformDeal(apiDeal) {
  if (!apiDeal || typeof apiDeal !== 'object') {
    return {};
  }

  return {
    id: apiDeal.id,
    restaurantId: apiDeal.restaurantId,
    targetType: apiDeal.targetType,
    discountType: apiDeal.discountType,
    discountValue: apiDeal.discountValue,
    validFrom: apiDeal.validFrom,
    validUntil: apiDeal.validUntil,
    isActive: apiDeal.isActive !== false
  };
}

/**
 * Transform deals response
 * @param {Array|Object} responseData - Response data from API
 * @returns {Array} - Array of transformed deal objects
 */
export function transformDealsResponse(responseData) {
  console.log("🚀 ~ transformDealsResponse ~ responseData:", responseData)
  const arr = Array.isArray(responseData?.data?.data)
    ? responseData.data?.data
    : Array.isArray(responseData?.data)
      ? responseData?.data
      : Array.isArray(responseData)
        ? responseData
        : [];
  console.log("🚀 ~ transformDealsResponse ~ arr:", arr)
  const now = Date.now();
  return arr.map(transformDeal).filter((d) => {
    if (!d.id || !d.isActive) return false;
    if (d.validUntil && new Date(d.validUntil).getTime() < now) return false;
    return true;
  });
}

export default {
  transformDeal,
  transformDealsResponse
};
